import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

interface INavLink {
  label: string;
  icon: string;
  link: string[];
}

/** Side menu for the admin shell. Replaces the app's ui-admin header (which pulled in @curbnturf/auth-modal + status). */
@Component({
  selector: 'admin-header',
  standalone: true,
  imports: [IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonTitle, IonToolbar, RouterLink],
  template: `
    <ion-menu type="reveal" contentId="main-content">
      <ion-header>
        <ion-toolbar>
          <ion-title>Admin Sections</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          @for (item of links; track item.label) {
            <ion-item lines="full" detail="true" [routerLink]="item.link">
              <ion-icon slot="start" [name]="item.icon" color="orange"></ion-icon>
              <ion-label>{{ item.label }}</ion-label>
            </ion-item>
          }
        </ion-list>
      </ion-content>
    </ion-menu>
  `,
})
export class AdminHeaderComponent {
  readonly links: INavLink[] = [
    { label: 'Users', icon: 'person', link: ['', 'users'] },
    { label: 'Reservations', icon: 'ticket', link: ['', 'reservations'] },
    { label: 'Private', icon: 'location', link: ['', 'sites'] },
    { label: 'Affiliates', icon: 'people', link: ['', 'affiliates'] },
    { label: 'Boondocking', icon: 'bonfire', link: ['', 'sites', 'boondock'] },
    { label: 'POIs', icon: 'pin', link: ['', 'pois'] },
    { label: 'Logs', icon: 'server', link: ['', 'log'] },
    { label: 'Caretakers', icon: 'key', link: ['', 'rating', 'caretaker'] },
    { label: 'Search', icon: 'search', link: ['', 'search'] },
    { label: 'Reports', icon: 'stats-chart', link: ['', 'reports'] },
    { label: 'Payouts', icon: 'wallet', link: ['', 'payouts'] },
    { label: 'Articles', icon: 'albums', link: ['', 'articles'] },
    { label: 'Article Builder', icon: 'create', link: ['', 'article-builder'] },
    { label: 'Email Templates', icon: 'mail', link: ['', 'email-template'] },
  ];
}
